import { render, staticRenderFns } from "./DateTimeDisplay.vue?vue&type=template&id=dbf704ae&"
import script from "./DateTimeDisplay.vue?vue&type=script&lang=ts&"
export * from "./DateTimeDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports